import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps extends ComponentProps<'div'> {
    size?: 'default' | 'narrow' | 'wide'
}

const sizes = {
    default: 'max-w-7xl',
    narrow: 'max-w-4xl',
    wide: 'max-w-[90rem]'
}

const Container: FC<ContainerProps> = ({ className, size = 'default', ...props }): ReactNode => {
    return (
        <div
            className={cn('mx-auto w-full px-5 sm:px-8 lg:px-10', sizes[size], className)}
            {...props}
        />
    )
}

export default Container
